/* ============ Lumiere Joyeria - global.js ============ */
(function () {
  'use strict';

  /* ---- Mobile nav ---- */
  document.addEventListener('click', function (e) {
    var burger = e.target.closest('[data-menu-open]');
    if (burger) {
      var nav = document.querySelector('.mobile-nav');
      if (nav) nav.classList.add('is-open');
    }
    if (e.target.closest('[data-menu-close]')) {
      var n = document.querySelector('.mobile-nav');
      if (n) n.classList.remove('is-open');
    }
  });

  /* ---- Cart drawer ---- */
  var drawer = document.getElementById('CartDrawer');

  function openDrawer() { if (drawer) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); renderCart(); } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); } }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); }
  });

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('es-CL', { minimumFractionDigits: 0 });
  }

  function updateCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function renderCart() {
    var body = drawer && drawer.querySelector('[data-cart-body]');
    if (!body) return;
    body.innerHTML = '<p style="text-align:center;opacity:.6">Cargando...</p>';
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        if (!cart.items.length) {
          body.innerHTML = '<div class="empty-state"><p>Tu carrito esta vacio</p><a href="/collections/all" class="btn btn--outline">Seguir comprando</a></div>';
          return;
        }
        var html = '';
        cart.items.forEach(function (it) {
          html += '<div class="cart-drawer__row">' +
            '<img src="' + (it.image ? it.image.replace(/(\.[^.]+)$/, '_120x$1') : '') + '" alt="" width="64">' +
            '<div><div style="font-size:.9rem">' + it.product_title + '</div>' +
            (it.variant_title && it.variant_title !== 'Default Title' ? '<div style="font-size:.78rem;opacity:.6">' + it.variant_title + '</div>' : '') +
            '<div style="font-size:.82rem;opacity:.7">' + it.quantity + ' x ' + money(it.final_price) + '</div>' +
            '<button data-remove="' + it.key + '" style="background:none;border:0;font-size:.72rem;text-decoration:underline;cursor:pointer;padding:4px 0;opacity:.6">Quitar</button></div>' +
            '<div style="font-size:.9rem">' + money(it.final_line_price) + '</div>' +
            '</div>';
        });
        html += '<div class="cart-drawer__foot">' +
          '<div style="display:flex;justify-content:space-between;margin-bottom:14px"><span>Subtotal</span><strong>' + money(cart.total_price) + '</strong></div>' +
          '<a href="/checkout" class="btn btn--block">Finalizar compra</a></div>';
        body.innerHTML = html;
      });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove]');
    if (rm) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: rm.getAttribute('data-remove'), quantity: 0 })
      }).then(function () { renderCart(); });
    }
  });

  /* ---- AJAX add to cart ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Agregando...'; btn.disabled = true; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.textContent = original; btn.disabled = false; }
        openDrawer();
      })
      .catch(function () { if (btn) { btn.textContent = original; btn.disabled = false; } });
  });

  /* ---- Quantity steppers ---- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty]');
    if (!step) return;
    var input = step.parentElement.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v += step.getAttribute('data-qty') === 'up' ? 1 : -1;
    input.value = Math.max(1, v);
  });

  /* ---- Product gallery thumbs ---- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var gal = thumb.closest('.product__gallery');
    var main = gal && gal.querySelector('[data-main-img]');
    if (main) main.src = thumb.getAttribute('data-thumb');
    gal.querySelectorAll('[data-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
    thumb.setAttribute('aria-current', 'true');
  });

  /* init cart count on load */
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); });
})();
